/**
 * CustomerIdentification
 * Provides identity validation based off information submitted for specific customer.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface QuestionAnswerInterface { 
    /**
     * The identification element that pertains to the question.
     */
    questionType: string;
    /**
     * Selected answer to the generated questions. This is the actual text of the answer provided.
     */
    questionAnswer: string;
}

